export default __webpack_public_path__ + "static/media/Infinity-1s-200px.8096a92f.gif";